

















































































































import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue from 'vue'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import { Prop } from 'vue-property-decorator'
import { TypedForm } from '@/shared/forms/typed-form'
import {
  EditProjectForm,
  editProjectFormMapping,
} from '@/business/project/components/edit-project/edit-project-form'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { Injector } from '@/config/dependency-injection'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { UPDATE_PROJECT } from '@/business/project/store/types'
import UnifyFormToggle from '@/shared/components/unify/unify-form-toggle.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { ProjectResponse } from '@/api/generated'
import { NotificationService } from '@/shared/services/notification-service'
import RespondecoResourceChooser from '@/shared/components/respondeco-resource-chooser.vue'
import { projectRequestResponseMapping } from '@/business/project/models/project-request-response-mapping'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import RespondecoBlock from '@/shared/components/respondeco-block.vue'
import RespondecoSaveBar from '@/shared/components/respondeco-save-bar.vue'
import ProjectPartners from '@/business/project/components/project-partners.vue'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import RespondecoCategories from '@/shared/components/respondeco-categories.vue'
import RespondecoResourceGallery from '@/shared/components/respondeco-resource-gallery.vue'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import EditProjectAbout from '@/business/project/components/edit-project/edit-project-about.vue'
import EditProjectPartners from '@/business/project/components/edit-project/edit-project-partners.vue'
import EditProjectLearnings from '@/business/project/components/edit-project/edit-project-learnings.vue'
import { ProjectService } from '@/business/project/project-service'
import { environmentConfiguration } from '@/config/environments'
import { HomeService } from '@/business/home/home-service'

@Component({
  name: 'edit-branded-project',
  components: {
    EditProjectLearnings,
    EditProjectPartners,
    EditProjectAbout,
    RespondecoFormGroup,
    RespondecoResourceGallery,
    RespondecoCategories,
    RespondecoValidationFeedback,
    RespondecoResourceChooser,
    UnifyTextarea,
    ProjectPartners,
    RespondecoSaveBar,
    RespondecoBlock,
    RespondecoEditor,
    UnifyButton,
    UnifyFormToggle,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoTypedForm,
    RespondecoLoadingIndicator,
    RespondecoTopBar,
  },
})
export default class EditOfferReport extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Number,
  })
  public readonly offerId!: number

  public form!: TypedForm<ProjectResponse, EditProjectForm>
  public loading: boolean = true
  public project: ProjectResponse | null = null

  private homeService = Injector.get(HomeService)
  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private projectService = Injector.get(ProjectService)

  private projectRequestResponseMapping = projectRequestResponseMapping()

  get saving() {
    return this.loaderHelper.isLoading(UPDATE_PROJECT)
  }

  public data() {
    return {
      form: new TypedForm(
        editProjectFormMapping(environmentConfiguration().branding === 'konstanz'),
        this
      ),
      original: undefined,
    }
  }

  public mounted() {
    this.projectService
      .getOfferReport(this.offerId)
      .then(project => {
        this.project = project
        this.form.reset(project)

        if (project.id === -1) {
          this.$v.$touch()
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  public validations() {
    const validations: any = this.form.validations()

    validations.form.value.learnings = {
      $each: {},
    }

    return validations
  }

  public reset(): void {
    this.form.reset(this.project!)
  }

  public submit(): void {
    this.$v.$touch()

    if (this.form.invalid === false) {
      const mergedModel: ProjectResponse = this.form.serialize(this.project!)
      const projectRequest = this.projectRequestResponseMapping.deserialize(mergedModel)

      let request: Promise<ProjectResponse>

      if (mergedModel.id === -1) {
        request = this.projectService.createProject(projectRequest)
      } else {
        request = this.projectService.updateProject(projectRequest, mergedModel.id)
      }

      request
        .then(project => {
          this.project = project
          this.reset()
        })
        .then(() => {
          this.homeService.konstanz$.markStale()
          this.notificationService.success('project.edit.successful_save')
        })
        .catch(this.notificationService.errorHandler())
    }
  }

  public updateCategories(categories: string[]) {
    this.form.patch({
      categories,
    })
  }
}
